import MakesPopularity from "../components/makes/MakesPopularity"
import MakesAll from "../components/makes/MakesAll";
import AddNewMake from "../components/makes/AddNewMake";
import MakesSynonyms from "../components/makes/MakesSynonyms";

import { useDispatch } from "react-redux";

import { useEffect } from 'react';

import { makes as actionsMakes, regions as actionsRegions } from "../store/actions";

const { getMakes } = actionsMakes;
const { getRegions } = actionsRegions;

const Makes = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMakes());
        dispatch(getRegions());
    }, []);

    return (

        <div className="flex flex-wrap -mx-2 overflow-hidden sm:-mx-4 md:-mx-6 lg:-mx-1">

            <div className="my-2 px-2 w-1/4 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                <MakesAll  />
                <div className="mb-2"></div>
                <AddNewMake />
            </div>

            <div className="my-2 px-2 w-1/4 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                <MakesSynonyms />
            </div>

            <div className="my-2 px-2 w-1/2 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                <MakesPopularity />
            </div>

        </div>

    );
}

export default Makes;